// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"header_wrapper__8VLPZ","inner":"header_inner__Bq4QX","logo":"header_logo__x2KMD"};